import React from 'react';

// Copmonents
import cloneDeep from 'lodash/cloneDeep';

import i18n from '@components/i18n/i18n';
import ButtonSocialComponent from '@shcc/components/buttons/ButtonSocialComponent/ButtonSocialComponent';
import SectionContainerComponent from '@shcc/components/section/SectionContainerComponent/SectionContainerComponent';
import SectionContentComponent from '@shcc/components/section/SectionContentComponent/SectionContentComponent';
import SwitchLanguageComponent from '@shcc/components/SwitchLanguageComponent/SwitchLanguageComponent';

// Components - local
import ButtonLinkComponent from './components/ButtonLinkComponent/ButtonLinkComponent';
import ButtonPrivacyComponent from './components/ButtonPrivacyComponent/ButtonPrivacyComponent';
// import NewsletterComponent from './components/NewsletterComponent/NewsletterComponent';

// Utils & Helpers
import translate from '@helpers/translate';
import { getLocalizedContent as l } from '@helpers/languages';
// Styles & Data
import styles from './FooterComponent.module.scss';
import content from './FooterComponent.json';
// Drupal data
import { useFooter } from '@hooks';
import NewsletterComponent from '@shcc/components/FooterComponent/components/NewsletterComponent/NewsletterComponent';

const FooterComponent = ({ location }) => {
  const lng = i18n.language;
  let footer = useFooter();

  // TODO: Quick hack until we fix the translate func that mutates the content
  const nextContent = cloneDeep(content);
  const data = { ...translate(nextContent, lng) };

  return (
    <>
      <SectionContainerComponent
        className={[styles.container, styles.brown].join(' ')}
      >
        {location?.pathname?.includes('portal') ||
        location?.pathname?.includes('commerce') ? null : (
          <SectionContentComponent
            className={[styles.content, styles.newsletter].join(' ')}
          >
            {/*{location &&*/}
            {/*location.pathname.indexOf('subscribe') !== -1 ? null : (*/}
            {/*  <NewsletterComponent data={data.newsletter} />*/}
            {/*)}*/}
          </SectionContentComponent>
        )}
      </SectionContainerComponent>
      <div className={styles.container}>
        <footer className={styles.footer}>
          <SectionContentComponent
            className={[styles.content, styles.top].join(' ')}
          >
            {footer.slice(0, 3).map((group, index) => (
              <div key={index}>
                <p>{l(group.title, lng)}</p>
                <ul key={index}>
                  {group.children.map((child, index) => (
                    <li key={index}>
                      <ButtonLinkComponent data={child} language={lng} />
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </SectionContentComponent>
          <SectionContentComponent
            className={[styles.content, styles.bottom].join(' ')}
          >
            <div className={styles.group}>
              <SwitchLanguageComponent />
            </div>
            <div className={styles.group}>
              {data.socialMedia && (
                <div className={styles.socialMedia}>
                  <ButtonSocialComponent
                    type="instagram"
                    data={data.socialMedia.instagram}
                  />
                  <ButtonSocialComponent
                    type="twitter"
                    data={data.socialMedia.twitter}
                  />
                  <ButtonSocialComponent
                    type="youtube"
                    data={data.socialMedia.youtube}
                  />
                  <ButtonSocialComponent
                    type="facebook"
                    data={data.socialMedia.facebook}
                  />
                </div>
              )}
            </div>
            <ul className={[styles.group, styles.slash].join(' ')}>
              {footer[3].children.map((child, index) => (
                <li key={index}>
                  <ButtonPrivacyComponent data={child} language={lng} />
                </li>
              ))}
            </ul>
            <ul className={[styles.group, styles.copyright].join(' ')}>
              {footer[4].children.map((child, index) => (
                <li key={index}>
                  <span>{l(child.title, lng)}</span>
                </li>
              ))}
            </ul>
          </SectionContentComponent>
        </footer>
      </div>
    </>
  );
};

export default FooterComponent;
